import { TimeFormatOptions, Timeslot } from '@griply/types';
import { format } from 'date-fns';

import { formatDurationLabel } from './format-duration-label';
import { formatTimeRange } from './format-time-range';
import { isNumber } from './is-number';

export type FormatTimeslotLabelOptions = {
  timeFormat: TimeFormatOptions;
  isNL: boolean;
  /** Rendered when the timeslot carries no start time. Omit to render nothing. */
  allDayLabel?: string;
};

export const formatTimeslotLabel = (
  timeslot: Timeslot | null | undefined,
  { timeFormat, isNL, allDayLabel }: FormatTimeslotLabelOptions,
): string => {
  const startTime = timeslot?.startTime;
  const duration = timeslot?.duration;

  // allDay — midnight is `0`, so this must stay an isNumber check, never a truthiness one
  if (!isNumber(startTime)) {
    const durationLabel = duration ? formatDurationLabel(duration, isNL) : null;

    return [allDayLabel, durationLabel].filter(Boolean).join(', ');
  }

  const startDate = new Date();
  startDate.setHours(0, 0, 0, startTime);

  // startTime
  if (!duration) {
    return format(startDate, timeFormat);
  }

  // range
  const endDate = new Date();
  endDate.setHours(0, 0, 0, startTime + duration);

  return formatTimeRange(startDate, endDate, timeFormat);
};
